export function isRpcResult(value) {
    return (typeof value === 'object' &&
        value !== null &&
        '__rpcResult' in value &&
        value.__rpcResult);
}
